module.exports = __webpack_public_path__ + "media/components/country-flag/static/sv-850a3ce99c9eabdcc16120810b54afe7.svg";